import React from 'react';
import Icon from '../../../components/AppIcon';

const industries = [
  'Healthcare & MedTech',
  'Financial Services & Capital Markets',
  'Manufacturing & Robotics',
  'Retail & CPG',
  'AgTech'
];

const IndustriesSection = () => {
  return (
    <section className="py-20 relative text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center space-x-3 mb-8">
          <div className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
            <Icon name="Briefcase" size={20} color="white" />
          </div>
          <h2 className="text-4xl font-bold text-white">Industries we cover</h2>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 enterprise-shadow border border-white/20">
          <div className="flex flex-wrap gap-3">
            {industries.map((name) => (
              <span key={name} className="text-sm px-3 py-2 rounded-full bg-white/10 text-white/90 border border-white/20">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;


